export default "__VITE_ASSET__a4f724f0__"